export default {
    init() {
        




		// function checkUsername(callback) {
		// 	const emailField = $('input[name="email"]')
			
		// 	if (emailField.length) {
		// 		let emailField_value = emailField.val()
		// 		let data = {
		// 			email: emailField_value,
		// 			action: "check_email_ajax",
		// 		}
			
		// 		fetch(ajaxurl, {
		// 			method: 'POST',
		// 			body: new URLSearchParams(data)
		// 		})
		// 		.then(response => response.json())
		// 		.then(response => {
		// 			console.log(response)
		// 			let email_exist = response.data.email_exists
		
		// 			if (email_exist === false) {
		// 				$('.onboarding-form__error').text('')
		// 				$('.onboarding-form__error').hide()
		// 				emailField.removeClass('invalid-input')
		// 			} else {
		// 				$('.onboarding-form__error').text('We\'re sorry, but it looks like the email address you entered is already registered. If you\'ve forgotten your password, you can use the forgot password option on the login page. If you need further assistance, please contact our support team at support@Paradigm21.Realty.')
		// 				$('.onboarding-form__error').show()
		// 				emailField.addClass('invalid-input')
		// 			}
		
		// 			callback(email_exist)
		// 		})
		// 		.catch(error => {
		// 			console.log(error)
		// 		})
		// 	}
		// }



		// function checkUsername() {
		// 	const emailField = $('input[name="username_email"]')
			
		// 	if (emailField.length) {
		// 		let emailField_value = emailField.val()
		// 		let data = {
		// 			email: emailField_value,
		// 			action: "check_email_ajax",
		// 		}
			
				
		// 		$.ajax({
		// 			url: my_ajax_object.ajax_url,
		// 			type: 'POST',
		// 			dataType: 'json',
		// 			data: data,
		// 			success: function (response) {
		// 				console.log(response)

		// 				if(response.success === true) {
		// 					return true
		// 				} else {
		// 					return false
		// 				}

		// 			},
		// 			error: function () {
		// 				return false
		// 			}
		// 		})

		// 	}
		// }






		function validatePasswords() {
			let all_pass = true
			let error_response = ''
		
			var password = $('input[name="password"]').val(),
				conf = $('input[name="password_confirm"]').val();
		
			var uppercase = password.match(/[A-Z]/),
				number = password.match(/[0-9]/),
				special = password.match(/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/),
				lowercase = password.match(/[a-z]/);
		
			if (password.length < 6) {
				error_response = 'Geslo mora imeti najmanj 6 simbolov'
				all_pass = false;
			}
		
			if (uppercase) {
			} else {
				all_pass = false;
				error_response = 'Geslo mora vključevati vsaj eno veliko črko'
			}
		
			if (lowercase) {
			} else {
				all_pass = false;
				error_response = 'Geslo mora vključevati vsaj eno malo črko'
			}
		
			if (number || special) {
			} else {
				all_pass = false;
				error_response = 'Geslo mora vključevati vsaj eno številko ali simbol'
			}
		
			if (password == conf && password != '') {
			} else {
				all_pass = false;
				error_response = 'Geslo in geslo za potrditev se ne ujemata'
			}

			if (!all_pass) {
				return error_response
			}
		
			// if (all_pass) {
			// 	checkInputs.removeClass('invalid-input');
			// } else {
			// 	checkInputs.addClass('invalid-input');
			// }
		
			return all_pass;
		}





		/**
		* Registracija restavracije
		**/
        $('#prijava-3-registracija-form').on('submit', function(e) {
            e.preventDefault()

			let this_form = $(this)
			let form_error_element = this_form.find('.form-response.error')
            let formData = this_form.serialize()
			let submitBtn = this_form.find('button[type="submit"]')
			submitBtn.prop('disabled', true)

			let passwordValid = validatePasswords()

			if (passwordValid !== true) {
				form_error_element.text(passwordValid).removeClass('hidden')
				submitBtn.prop('disabled', false)
				return false
			} else {
				form_error_element.addClass('hidden')
			}


			// let email_obstaja = checkUsername()
			// console.log(email_obstaja)
			// if (email_obstaja === true) {
			// 	form_error_element.text('Ta email naslov je že registriran. Prosimo, vpišite drug email naslov ali pa se prijavite na svoj račun na strani https://vivi.si/').removeClass('hidden')
			// 	submitBtn.prop('disabled', false)
			// 	return false
			// } else {
			// 	form_error_element.addClass('hidden')
			// }


			$.post(my_ajax_object.ajax_url, { action: 'registracija_3_restavracije_nonce' }, function(nonce) {
				$.ajax({
					url: my_ajax_object.ajax_url,
					type: 'POST',
					dataType: 'json',
					data: formData + '&action=registracija_3_restavracije_submit_ajax&security=' + encodeURIComponent(nonce),
					success: function (response) {
						if (response && response.success) {
							form_error_element.text('Uspešno ste se registrirali. Preusmerjamo vas na naslednji korak...').removeClass('hidden text-red border-red').addClass('success text-blue border-blue').show()

							setTimeout(function() {
								window.location.href = response.data.redirect_url;
							}, 1000)
						} else {
							form_error_element.text(response.data.error).removeClass('hidden')
							submitBtn.prop('disabled', false)
						}
					},
					error: function () {
						form_error_element.text('Prišlo je do napake pri pošiljanju. Preverite, ali ste vpisali pravilno povezavo v brskalnik in poskusite znova.').removeClass('hidden')
						submitBtn.prop('disabled', false)
					}
				})
			})
        })



    }
}